import type { COLOR } from '@george-labs.com/design-system';
import { TeaserModal } from '@george-labs.com/design-system';
import type { ComponentProps } from 'react';

import type { Severity } from '@api-client/temporary-messages';

export const getTemporaryMessageModalColor = (
    severity: Severity,
): ComponentProps<typeof TeaserModal>['color'] => {
    const SEVERITY_TO_COLOR: Record<Severity, COLOR> = {
        INFO: TeaserModal.COLOR.UI_BLUE_WEAK,
        WARNING: TeaserModal.COLOR.UI_YELLOW_WEAK,
        ERROR: TeaserModal.COLOR.UI_RED_WEAK,
    };

    return SEVERITY_TO_COLOR[severity];
};
